import classnames from 'classnames/bind'
import { HTMLAttributes } from 'react'

// Components
import Image from '@/components/common/Image'

// Styles
import styles from './style.module.scss'
const cx = classnames.bind(styles)

interface HotBrandCardProps {
  title: string
  coverImageUrl?: string
  logoImgUrl?: string
}

const HotBrandCard = ({ title, logoImgUrl, className, ...props }: HTMLAttributes<HTMLDivElement> & HotBrandCardProps) => {
  return (
    <div className={cx('hot-brand-card', className)} {...props}>
      <div className={cx('hot-brand-card__cover')}></div>
      <div className={cx('hot-brand-card__logo')}>
        <Image
          src={logoImgUrl}
          alt={title}
          style={{
            borderRadius: '50%',
          }}
          fill
        />
      </div>
      <div className={cx('hot-brand-card__title')}>{title}</div>
    </div>
  )
}

export default HotBrandCard
